/**
 * navigator.vendor is a constant of the engine rather than of the version a
 * feature shipped in: Blink reports 'Google Inc.' down to the oldest Android
 * WebView, which is the range a feature check for a recent API would miss.
 */
export function isChromium() {
  return navigator.vendor === 'Google Inc.';
}
